<template>
  <div>
     <Input search enter-button placeholder="Search by name" v-model="keyword" @on-search="handleSearch"/>
     <vxe-grid
        border='inner'
        resizable
        stripe
        showOverflow
        :data="tableData"
        :loading="loading"
        :columns="columns"
        ref="components"
        column-min-width="50"
        size="mini"
        row-id="id"
        :radio-config="{trigger: 'row', checkRowKey: account ?account.id : null}"
        @radio-change="handleCheckonAccount"
        >
      </vxe-grid>
  </div>

</template>

<script>
import { mapActions } from 'vuex'
import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
Vue.use(VXETable)
export default {
  name: 'PartSearchOctopart',
  props: {
    account: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      keyword: null,
      loading: false,
      columns: [
        { type: 'radio', field: 'id', title: 'ID', width: 80 },
        { field: 'crm_id', title: 'CRM ID', width: 120 },
        { field: 'account_number', title: 'Account number', width: 120, remoteSort: false },
        { field: 'name', title: 'Name', width: 450, remoteSort: false },
        { field: 'country_code', title: 'Country code', width: 80, remoteSort: false }
      ],
      tableData: [],
      selectedAccount: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions([
      'getAccounts'
    ]),
    async init() {
      this.selectedAccount = this.account
      if (this.account) {
        this.tableData = [_.cloneDeep(this.account)]
      } else {
        this.tableData = []
      }
    },
    handleSearch (name) {
      if (name) {
        this.loading = true
        this.getAccounts({
          name: name
        }).then(res => {
          this.tableData = res
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleCheckonAccount({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }) {
      this.selectedAccount = row
      this.$emit('update:account', this.selectedAccount)
      this.$emit('on-account-changed', this.selectedAccount)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
